import { Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ICreateVenue } from "../../../hooks/useCreateNewVenue";
import { useUserLogout } from "../../../hooks/useUserLogout";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import HomeLayout from "../../HomeLayout";
import { useGetMerchant } from "../../util/GetUsersVenues/useGetMerchant";
import ListLoading from "../../util/Loading";
import { WelcomeCreateVenue } from "./WelcomeCreateVenue";

export function WelcomeContainer() {
    const { t } = useTranslation();
    const { merchant } = useGetMerchant();
    const { apiData, isError, isLoading } = useAPIV2<any>(APIExtensions.registration, { query: "leads" });
    const [venueCreationObject, setVenueCreationObject] = useState<ICreateVenue | null>(null);
    const { logout } = useUserLogout();
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (isError) {
            setHasError(true);
        }
    }, [isError]);

    useEffect(() => {

        if (apiData && apiData.set_up_stage !== "Signed in") {
            try {
                let venue_location_value;
                if (apiData.venue_location) {
                    venue_location_value = apiData.venue_location.split('value"=>')
                        .pop().replaceAll('"', '');
                }
                const newObj = {
                    venue_location: { value: venue_location_value },
                    venue_data: {
                        venue_name: apiData.venue_name,
                        specialist_name: apiData.specialist_name ?? undefined,
                        specialist_email: apiData.specialist_email ?? undefined,
                        referral_code: apiData.referral_code ?? undefined,
                        reseller: apiData.reseller ?? undefined,
                        onboarding_source: apiData.onboarding_source,
                        country_code: apiData.processing_fee_plan_id ? undefined : venue_location_value,
                        contact_email: merchant && merchant.contact_email ? merchant.contact_email : undefined,
                        processing_fees_plans_id: apiData.processing_fee_plan_id ?? undefined,
                        integration_object_id: apiData?.metadata?.venue?.integration_object_id ?? undefined

                    },
                    venue_setting_data: {
                        mcc: apiData.mcc ?? undefined,
                        acquirer_name: apiData.acquirer_name ?? undefined,
                        mid: apiData.mid ?? undefined,
                    },
                }
                setVenueCreationObject(newObj);
            } catch (error) {
                setHasError(true);
            }
        }
        // eslint-disable-next-line
    }, [apiData, merchant]);

    console.log({ venueCreationObject });
    console.log({ merchant });

    return <HomeLayout>

        {
            isLoading &&
            <>
                <div>
                    {t("signup.welcome.venueCreation")}
                </div>
                <ListLoading />    
            </>
        }
        {
            venueCreationObject && 
                <WelcomeCreateVenue 
                    data={venueCreationObject} 
                    leadId={apiData.id} 
                />
        }
        {
            hasError && 
                <>
                    <div style={{textAlign: "center"}}>{t("signup.welcome.leadError")}</div>
                    <Button onClick={logout} color="default">{t('misc.logout')}</Button>
                </>
        }
        {
            !isLoading && (!apiData || apiData.set_up_stage === "Signed in") && 
                <>
                    <div style={{textAlign: "center"}}>{t("signup.welcome.venueCreateError")}</div>
                    <a href="mailto:support@yoello.com">support@yoello.com</a>
                    <Button onClick={logout} color="default">{t('misc.logout')}</Button>
                </>
        }
    </HomeLayout>
}